// extracted by mini-css-extract-plugin
module.exports = {"navBar":"NavBar_navBar__xR_oa","logo":"NavBar_logo__1zX6E","nav":"NavBar_nav__Xx0Gb","link":"NavBar_link__nXG89","btns":"NavBar_btns__22Kxb","links":"NavBar_links__3mbTT"};